import { render, staticRenderFns } from "./TodayCourses.vue?vue&type=template&id=04a9b873&"
import script from "./TodayCourses.vue?vue&type=script&lang=js&"
export * from "./TodayCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports